import React from 'react'
import classNames from 'classnames'

import { Icon } from 'pharmacy/src/display/icon'
import { Subtitle2, Subtitle3 } from 'pharmacy/src/typography'

import * as css from './lastUsedLegend.scss'
import * as chipCss from './lastUsedInfo.scss'

// Explains the "last used" chips and the non-obvious rules behind them, behind a
// small (?) so it stays out of the way until an editor wants it. Kept in sync
// with the three states in lastUsedInfo.js.
const STATES = [
  {
    chipClassName: chipCss.chipUsed,
    label: 'Sent',
    description: 'already delivered; the current version is what readers saw.',
  },
  {
    chipClassName: chipCss.chipUpdated,
    label: 'Updated since sent',
    description:
      'it went out, but the answer was edited afterward, so the current version hasn’t been delivered. Consider re-sending.',
  },
  {
    chipClassName: chipCss.chipNotUsed,
    label: 'Not sent',
    description: "hasn't gone out in a digest yet.",
  },
]

const NOTES = [
  'These colors and the "hide sent updates" filter look at digests only. Click a chip to see its newsletter history too — that\'s listed for reference, but it doesn\'t change the chip color or hide an update.',
  "This is per specialty: an answer sent in another specialty's digest doesn't count here. The same answer can read “sent” in one specialty and “not sent” in another.",
  'Dates shown are when the digest was sent, not when it was created.',
  "Skipped digests (never delivered) are ignored everywhere — they don't affect the chip color, the hide-sent filter, or the digest list in the popup.",
  'If an answer is edited after it\'s added to a digest but before that digest is sent, the edit still goes out with it, so it counts as sent — readers got that version. Only edits made after the digest has sent show as "updated since sent".',
]

class LastUsedLegend extends React.Component {
  state = {
    opened: false,
  }

  toggle = () => {
    this.setState((state) => ({ opened: !state.opened }))
  }

  render() {
    const { opened } = this.state

    return (
      <div className={css.container}>
        <Subtitle3 className={css.trigger} onClick={this.toggle}>
          <Icon className={css.triggerIcon} icon="info-circle" />
          What the colors mean
        </Subtitle3>
        {!opened ? null : (
          <div className={css.popover}>
            {STATES.map((state) => (
              <div key={state.label} className={css.stateRow}>
                <span className={classNames(css.chip, state.chipClassName)}>
                  <Icon className={css.chipIcon} icon="info-circle" />
                </span>
                <Subtitle3 className={css.stateText}>
                  <strong>{state.label}</strong> — {state.description}
                </Subtitle3>
              </div>
            ))}
            <hr className={css.divider} />
            <Subtitle2 className={css.notesHeader}>Good to know</Subtitle2>
            <ul className={css.notes}>
              {NOTES.map((note, index) => (
                <li key={index}>
                  <Subtitle3>{note}</Subtitle3>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    )
  }
}

export default LastUsedLegend
